/* Publish by EComposer at 2024-07-08 22:56:31*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-80umbrm4d2d"]=  window.__ectimmers["ecom-80umbrm4d2d"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    const settings = {"link":"none","lightbox":"no"};
                    const ID = 'ecom-80umbrm4d2d';
                    document.querySelectorAll('.ecom-80umbrm4d2d').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
;try{
 
} catch(error){console.error(error);}